<template>
	<transition
		:css="false"
		@enter="enter"
		@leave="leave"
	>
		<slot />
	</transition>
</template>

<script>
import gsap from 'gsap';

export default {
	methods: {
		enter( el, done ) {
			const buttons = el.getElementsByTagName( 'button' );
			if ( buttons.length ) {
				buttons[ 0 ].focus();
			}

			gsap.fromTo(
				el,
				{
					alpha: 0,
				},
				{
					alpha: 1,
					duration: 0.4,
					ease: 'power1.out',
					onComplete: done,
				},
			);
		},
		leave( el, done ) {
			gsap.to(
				el,
				{
					alpha: 0,
					duration: 0.3,
					ease: 'power1.in',
					onComplete: done,
				},
			);
		},
	},
};
</script>
